import SignIn from '@/views/SignIn/index.vue';
import SignOut from '@/views/SignOut/index.vue';

export default [
  {
    path: '/sign_out',
    name: 'SignOut',
    component: SignOut,
    meta: {
      titleType: 'authorization',
    },
  },
  {
    path: '/sign_in',
    name: 'SignIn',
    component: SignIn,
    meta: {
      titleType: 'authorization',
    },
  },
];
